var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import styled from '@emotion/styled';
import { width } from 'styled-system';
import loadable from '@loadable/component';
import { isTouchDevice } from '../DeviceDetector';
import GetElementWidth from './GetElementWidth';
export var LazyCarouselControls = loadable.lib(function () {
    return import('./LazyCarouselControls');
});
var FallbackContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  height: auto;\n  overflow: ", ";\n"], ["\n  display: flex;\n  width: 100%;\n  height: auto;\n  overflow: ", ";\n"])), function (_a) {
    var overflowHidden = _a.overflowHidden;
    return (overflowHidden ? 'hidden' : 'auto');
});
var FallbackItem = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: none;\n  ", ";\n"], ["\n  flex: none;\n  ", ";\n"])), width);
var CarouselContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: inherit;\n"], ["\n  width: inherit;\n"])));
/**
 * Lazy loads the glide carousel, using the first slide as a fallback
 * while the chunk is loading. Supports only part of glide props, but
 * can be easily expanded. For the full list of glide props, refer to
 * glide docs:
 *
 * https://glidejs.com/docs/
 */
var LazyCarousel = /** @class */ (function (_super) {
    __extends(LazyCarousel, _super);
    function LazyCarousel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            initialContainerWidth: null,
            isHovered: false,
        };
        _this.setInitialContainerWidth = _this.setInitialContainerWidth.bind(_this);
        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
        return _this;
    }
    LazyCarousel.prototype.setInitialContainerWidth = function (initialContainerWidth) {
        this.setState({
            initialContainerWidth: initialContainerWidth,
        });
    };
    LazyCarousel.prototype.onMouseEnter = function () {
        this.setState({ isHovered: true });
    };
    LazyCarousel.prototype.onMouseLeave = function () {
        this.setState({ isHovered: false });
    };
    LazyCarousel.prototype.render = function () {
        var _this = this;
        var _a = this.props, showControlsOnTouchDevice = _a.showControlsOnTouchDevice, renderCenterLeftControls = _a.renderCenterLeftControls, renderCenterRightControls = _a.renderCenterRightControls, renderBottomCenterControls = _a.renderBottomCenterControls, beforeSlide = _a.beforeSlide, afterSlide = _a.afterSlide, children = _a.children, slidesToShow = _a.slidesToShow, slidesToScroll = _a.slidesToScroll, frameOverflow = _a.frameOverflow, sliderOverflow = _a.sliderOverflow, slideWidth = _a.slideWidth, fixedSlideWidth = _a.fixedSlideWidth, scrollToTheLastSlide = _a.scrollToTheLastSlide, fallbackSlideWidth = _a.fallbackSlideWidth, cellSpacing = _a.cellSpacing, wrapAround = _a.wrapAround, swipeThreshold = _a.swipeThreshold, autoplay = _a.autoplay, autoplayInterval = _a.autoplayInterval, pauseOnHover = _a.pauseOnHover, overflowHidden = _a.overflowHidden, showControlsOnHover = _a.showControlsOnHover, disabled = _a.disabled, startAt = _a.startAt, keyboard = _a.keyboard, centerSlides = _a.centerSlides;
        var _b = this.state, initialContainerWidth = _b.initialContainerWidth, isHovered = _b.isHovered;
        /**
         * Before carousel is loaded we will render all the slides in the container, that
         * "emulates" glide scrollable container. All the items will be wrapped in a scrollable
         * container and each item will be also wrapped in a fallback, that will size the item
         * container properly.
         *
         * IMPORTANT: If your carousel items have dynamic, javascript based `slideWidth` provided
         * to the component, you should also provide `fallbackSlideWidth`, that is a "static" representation
         * of sizes that will be provided as `slideWidth`
         *
         * For the example of usage, see `common-visual-navigation` component
         */
        var fallback = (React.createElement(GetElementWidth, { onWidthChange: this.setInitialContainerWidth, disabled: slideWidth === null },
            React.createElement(FallbackContainer, { overflowHidden: overflowHidden }, React.Children.map(children, function (child, index) { return (React.createElement(FallbackItem, { width: fallbackSlideWidth, key: index }, child)); }))));
        var showControls = (showControlsOnTouchDevice || !isTouchDevice()) &&
            (!showControlsOnHover || isHovered);
        return (React.createElement(LazyCarouselControls, { fallback: fallback }, function (_a) {
            var Carousel = _a.Carousel, CenterLeftControls = _a.CenterLeftControls, CenterRightControls = _a.CenterRightControls, BottomCenterControls = _a.BottomCenterControls;
            return (React.createElement(CarouselContainer, { onMouseEnter: _this.onMouseEnter, onMouseLeave: _this.onMouseLeave },
                React.createElement(Carousel, { initialContainerWidth: initialContainerWidth, renderCenterLeftControls: showControls
                        ? renderCenterLeftControls || CenterLeftControls
                        : false, renderCenterRightControls: showControls
                        ? renderCenterRightControls || CenterRightControls
                        : false, renderBottomCenterControls: disabled
                        ? false
                        : renderBottomCenterControls || BottomCenterControls, beforeSlide: beforeSlide, afterSlide: afterSlide, slidesToShow: slidesToShow, slidesToScroll: slidesToScroll, frameOverflow: frameOverflow, sliderOverflow: sliderOverflow, slideWidth: slideWidth, fixedSlideWidth: fixedSlideWidth, cellSpacing: cellSpacing, wrapAround: wrapAround, swipeThreshold: swipeThreshold, autoplay: autoplay, autoplayInterval: autoplayInterval, pauseOnHover: pauseOnHover, scrollToTheLastSlide: scrollToTheLastSlide, disabled: disabled, startAt: startAt, keyboard: keyboard, centerSlides: centerSlides }, children)));
        }));
    };
    LazyCarousel.defaultProps = {
        frameOverflow: 'hidden',
        sliderOverflow: 'hidden',
        slidesToShow: 1,
        slideWidth: 1,
        fallbackSlideWidth: 1,
        wrapAround: false,
        autoplay: false,
        autoplayInterval: 3000,
        pauseOnHover: false,
        overflowHidden: false,
        disabled: false,
    };
    return LazyCarousel;
}(React.Component));
export default LazyCarousel;
var templateObject_1, templateObject_2, templateObject_3;
